<template>
  <div id="domain-black-list">
    <div class="expanded row">
      <div class="small-12 medium-5 columns">
        <label for="domains">{{ 'Domains'|t }}</label>
        <textarea id="domains" name="domains" v-model="domains" rows="20"></textarea>
        <button class="medium success button" @click="submitForm">{{ 'Submit'|t }}</button>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api';
  import router from '@/routes';

  export default {
    name: 'BlackList',
    created() {
      let self = this;
      api.getDomainBlacklist(
        null,
        data => self.domains = data.domains.join("\n")
      );
    },
    data() {
      return {
        domains: "",
      }
    },
    methods: {
      submitForm() {
        api.setDomainBlacklist(
          {
            domains: this.domains.split("\n").filter(word => word.length > 0),
          },
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Changes were saved."
            }, {root: true});
            router.push({name: 'domain.collection'});
          }
        );
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/domain/BlackList.vue